export default __webpack_public_path__ + "static/media/default-avatar.e44fc4e2.png";